import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { Link, useI18next } from 'gatsby-plugin-react-i18next';
import { I18nextContext } from 'gatsby-plugin-react-i18next';
import './LanguageLocalization.scss';
import {
  FUNCTIONS_DE,
  FUNCTIONS_EN,
  FUNCTIONS_PT,
  LANGUAGE_REFERENCE_PAGE,
  STRUCTURES_DE,
  STRUCTURES_EN,
  STRUCTURES_PT,
  VARIABLES_DE,
  VARIABLES_EN,
  VARIABLES_PT,
} from '../../utils/constants';

interface LanguageLocalizationProps {
  localization?: boolean;
}

/*
 * This component is actually used only for language-reference and reference tutorials.
 * It's a workaround to let Docs not translated but the reference yes.
 */
export default function LanguageLocalization(props: LanguageLocalizationProps): React.ReactElement {
  const { localization } = props;
  const { changeLanguage } = useI18next();
  const context = React.useContext(I18nextContext); //Use this react context to access language information about the page
  const location = useLocation();
  const parts = location.pathname.split('/');

  const { languages, originalPath } = useI18next();

  useEffect(() => {
    const customSelect = document.querySelector('.custom-select');
    const selectBtn = document.querySelector('.select-button');

    const optionsList = document.querySelectorAll('.select-dropdown li');

    // add click event to select button
    selectBtn.addEventListener('click', () => {
      // add/remove active class on the container element
      customSelect.classList.toggle('active');
      // update the aria-expanded attribute based on the current state
      selectBtn.setAttribute('aria-expanded', selectBtn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });

    optionsList.forEach((option) => {
      function handler(e) {
        // Click Events
        if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
          customSelect.classList.remove('active');
        }
      }

      option.addEventListener('keyup', handler);
      option.addEventListener('click', handler);
    });
  }, []);

  function getPath(lng, actualPath) {
    switch (decodeURIComponent(actualPath)) {
      case FUNCTIONS_EN:
        return lng === 'de' ? FUNCTIONS_DE : lng === 'pt' ? FUNCTIONS_PT : FUNCTIONS_EN;
      case FUNCTIONS_DE:
        return lng === 'en' ? FUNCTIONS_EN : lng === 'pt' ? FUNCTIONS_PT : FUNCTIONS_DE;
      case FUNCTIONS_PT:
        return lng === 'en' ? FUNCTIONS_EN : lng === 'de' ? FUNCTIONS_DE : FUNCTIONS_PT;
      case VARIABLES_EN:
        return lng === 'de' ? VARIABLES_DE : lng === 'pt' ? VARIABLES_PT : VARIABLES_EN;
      case VARIABLES_DE:
        return lng === 'en' ? VARIABLES_EN : lng === 'pt' ? VARIABLES_PT : VARIABLES_DE;
      case VARIABLES_PT:
        return lng === 'de' ? VARIABLES_DE : lng === 'en' ? VARIABLES_EN : VARIABLES_PT;
      case STRUCTURES_EN:
        return lng === 'de' ? STRUCTURES_DE : lng === 'pt' ? STRUCTURES_PT : STRUCTURES_EN;
      case STRUCTURES_DE:
        return lng === 'en' ? STRUCTURES_EN : lng === 'pt' ? STRUCTURES_PT : STRUCTURES_DE;
      case STRUCTURES_PT:
        return lng === 'en' ? STRUCTURES_EN : lng === 'de' ? STRUCTURES_DE : STRUCTURES_PT;
      default:
        break;
    }
  }

  return (
    <div className="custom-select">
      <button className="select-button">
        <span className="selected-value">{parts.includes('language-reference') ? context.language : location.pathname.substr(1, 2)}</span>
        <span className="custom-select__arrow"></span>
      </button>
      <ul className="select-dropdown" role="listbox" id="select-dropdown">
        {languages.map((lng) => (
          <li key={lng}>
            {parts.includes('language-reference') && !localization ? (
              <Link to={originalPath} language={lng} onClick={() => changeLanguage(lng)}>
                {lng}
              </Link>
            ) : (
              <a
                onClick={() => changeLanguage(lng)}
                href={LANGUAGE_REFERENCE_PAGE + lng + '/' + getPath(lng, parts[3]) + '/' + parts[4] + '/' + parts[5]}
              >
                {lng}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
